// extracted by mini-css-extract-plugin
export default {"e-wrapper":"next-bed-view_e-wrapper__TWEua"};